/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Emptystate_Importfromsalesforce4Inputs */

const en_coinvestments_prospects_emptystate_importfromsalesforce4 = /** @type {(inputs: Coinvestments_Prospects_Emptystate_Importfromsalesforce4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Prospects`)
};

/**
* | output |
* | --- |
* | "Import Prospects" |
*
* @param {Coinvestments_Prospects_Emptystate_Importfromsalesforce4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_emptystate_importfromsalesforce4 = /** @type {((inputs?: Coinvestments_Prospects_Emptystate_Importfromsalesforce4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Emptystate_Importfromsalesforce4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_emptystate_importfromsalesforce4(inputs)
});
export { coinvestments_prospects_emptystate_importfromsalesforce4 as "coInvestments_prospects_emptyState_importFromSalesforce" }